import React from "react";
import { Typography, Button, Space } from "antd";

type Status = "loading" | "error" | "success" | "idle" | undefined;

interface Props {
  onEnable: () => void;
  serviceName: string;
  createRateCardStatus: Status;
}

const EnableService: React.FC<Props> = ({ onEnable, serviceName = "warehouse", createRateCardStatus }) => {
  return (
    <div className="text-center">
      <Space direction="vertical" size={25}>
        <div>
          <Typography.Title disabled>No {serviceName} Rate Card</Typography.Title>
          <Typography.Paragraph disabled>
            If you wish to add {serviceName} rate card, please click &ldquo;Enable&rdquo; button
          </Typography.Paragraph>
        </div>
        <Button type="primary" size="large" onClick={onEnable} loading={createRateCardStatus === "loading"}>
          Enable
        </Button>
      </Space>
    </div>
  );
};

export default EnableService;
